import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";

import {
  Col,
  Form,
  Input,
  Spin,
  Button,
  Modal,
  Breadcrumb,
} from "antd";

import { HomeOutlined } from "@ant-design/icons";
import { openNotification } from "../../../../components/Notification";
import PageHeader from "../../../../components/PageHeader";
import { SecaoCard } from "../../../../components/SecaoCard";
import { SelectBuscavel } from "../../../../components/SelectBuscavel";
import { FormActions } from "../../../../components/FormActions";
import { DenunciaTabela } from "../../../Denuncia/components/DenunciaTabela";
import { scrollBotton, urls } from "../../../../utils";
import {
  subTipoViolacaoService,
  tipoViolacaoService,
} from "../../../../services";

const { TextArea } = Input;

const EditSubtipo = ({ onView }) => {
  const history = useHistory();
  const { codigo } = useParams();

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [isCreateSubtipo, setIsCreateSubtipo] = useState(false);
  const [tiposDenuncia, setTiposDenuncia] = useState([]);
  const [viewList, setViewList] = useState(false);
  const [inBotton, setInBotton] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [subtipoEdit, setSubtipoEdit] = useState(null);

  const getDenunciationTypes = async () => {
    setLoading(true);
    await tipoViolacaoService
      .loadViolationTypes()
      .then((response) => setTiposDenuncia(response.data))
      .catch((reason) =>
        openNotification(
          "error",
          <strong>Erro!</strong>,
          "Ocorreu um erro ao buscar os Tipos de Denúncia."
        )
      );
    setLoading(false);
  };

  const getSubTipo = async (codigo) => {
    try {
      const response = await subTipoViolacaoService.getViolationSubType(codigo);
      const { data } = response;

      setSubtipoEdit({
        ...data,
        tiposViolacao: data.tiposViolacao.map((tipo) => tipo.codigo),
      });
      form.setFieldsValue({
        ...data,
        tiposViolacao: data.tiposViolacao.map((tipo) => tipo.codigo),
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddSubtipo = async ({
    descricao,
    fundamentacao,
    tiposViolacao,
  }) => {
    const newTiposviolacao = tiposViolacao?.map((tipo) => ({ codigo: tipo }));

    try {
      await subTipoViolacaoService.createViolationSubType({
        descricao,
        fundamentacao,
        tiposViolacao: newTiposviolacao,
      });
      openNotification(
        "success",
        <strong>Sucesso!</strong>,
        "Subtipo criado com sucesso!"
      );
    } catch (reason) {
      openNotification(
        "error",
        <strong>Erro!</strong>,
        "" + reason?.response?.data?.detail
      );
    } finally {
      history.push(`${urls.CLASSIFICACOES}?mode=subtipos`);
    }
  };

  const handleUpdateSubtipo = async ({
    descricao,
    fundamentacao,
    tiposViolacao,
  }) => {
    const newTiposviolacao = tiposViolacao?.map((tipo) => ({ codigo: tipo }));

    try {
      await subTipoViolacaoService.editViolationSubType(codigo, {
        descricao,
        fundamentacao,
        tiposViolacao: newTiposviolacao,
      });
      openNotification(
        "success",
        <strong>Sucesso!</strong>,
        "Subtipo atualizado com sucesso!"
      );
    } catch (reason) {
      openNotification(
        "error",
        <strong>Erro!</strong>,
        "" + reason?.response?.data?.detail
      );
    } finally {
      history.push(`${urls.CLASSIFICACOES}?mode=subtipos`);
    }
  };

  useEffect(() => {
    getDenunciationTypes();

    codigo ? getSubTipo(codigo) : setIsCreateSubtipo(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigo]);

  const renderForm = () => (
    <Spin spinning={loading} size="large">
      {!loading && (
        <Form
          onFieldsChange={() =>
            setHasError(
              !!form.getFieldsError().find(({ errors }) => errors?.length >= 1)
            )
          }
          name="novo_tema"
          onFinish={isCreateSubtipo ? handleAddSubtipo : handleUpdateSubtipo}
          layout="vertical"
          form={form}
        >
          <SecaoCard title="Dados do subtipo">
          <Col span={24}>
            <Form.Item
              name="descricao"
              label={<span>Descrição:</span>}
              rules={
                !onView && [
                  { required: true, message: "Este campo é obrigatório!" },
                ]
              }
            >
              <Input placeholder="Insira a descrição do subtipo" allowClear />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="fundamentacao"
              label={<span>Fundamentação:</span>}
              rules={
                !onView && [
                  { required: true, message: "Este campo é obrigatório!" },
                ]
              }
            >
              <TextArea disabled={onView} allowClear autoSize/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="tiposViolacao" label={<span>Tipos:</span>}>
              <SelectBuscavel
                allowClear
                showArrow
                mode="tags"
                placeholder="Selecione os tipos"
                id="tema"
                options={tiposDenuncia?.map(({ codigo, descricao }) => ({
                  label: descricao,
                  value: codigo,
                  key: codigo,
                }))}
              />
            </Form.Item>
          </Col>
          </SecaoCard>

            {!onView && !hasError && (
              <FormActions
                inBotton={inBotton}
                actions={[
                  <Button
                    type="primary"
                    ghost
                    onClick={() =>
                      history.push(`${urls.CLASSIFICACOES}?mode=subtipos`)
                    }
                  >
                    {isCreateSubtipo ? (
                      <span>cancelar</span>
                    ) : (
                      <span>cancelar edições</span>
                    )}
                  </Button>,
                  <Button type="primary" htmlType="submit">
                    {isCreateSubtipo ? (
                      <span>cadastrar subtipo</span>
                    ) : (
                      <span>salvar edições</span>
                    )}
                  </Button>,
                ]}
              />
            )}
        </Form>
      )}
    </Spin>
  );

  return (
    <div id="sectionMain" onScroll={(e) => setInBotton(scrollBotton(e))}>
      <Breadcrumb id="breadcrumb">
        <Breadcrumb.Item key="home">
          <Link to="">
            <HomeOutlined />
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item key="gerenciamento">gerenciamento</Breadcrumb.Item>
        <Breadcrumb.Item key="classificacoes">
          <Link to={urls.INSTITUICOES_LIST}>classificações</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item key="temas">
          <Link to={`${urls.CLASSIFICACOES}?mode=subtipos`}>subtipos</Link>
        </Breadcrumb.Item>

        {isCreateSubtipo ? (
          <Breadcrumb.Item key="criar">
            <strong>cadastrar tipo</strong>
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item key="editar">
            <strong>editar subtipo</strong>
          </Breadcrumb.Item>
        )}
      </Breadcrumb>

      <div className="section-children">
        <div className="container-section">
          <PageHeader
            titulo={
              isCreateSubtipo
                ? "CADASTRAR SUBTIPO"
                : subtipoEdit?.descricao.toUpperCase()
            }
            subtitulo={
              isCreateSubtipo
                ? "Inserir informações sobre o subtipo"
                : "Editar informações sobre o subtipo"
            }
          />
          {renderForm()}
        </div>
      </div>

      <Modal
        title={"DENÚNICAS QUE CONTÉM ENCAMINHAMENTOS PARA ESSA INSTITUIÇÃO"}
        visible={viewList}
        onCancel={() => setViewList(false)}
        width={"90%"}
        centered
        footer={[
          <Button type="primary" onClick={() => setViewList(false)}>
            voltar
          </Button>,
        ]}
      >
        <DenunciaTabela
          showStatus
          filtro={{ codigoInstituicaoDestinataria: codigo }}
          searchClassificacao={false}
        />
      </Modal>
    </div>
  );
};

export default EditSubtipo;
